function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { findDesiredCamera } from '../Util.js';
import { DEFAULT_CONSTRAINTS } from '../Constants.js';
import S from './CodeScanner.css';
export default class CodeScanner extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    eventData: PropTypes.any,
    className: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
    onError: PropTypes.func,
    scanMilliseconds: PropTypes.number,
    decodeMilliseconds: PropTypes.number,
    scanning: PropTypes.bool,
    scanArea: PropTypes.shape({
      x: PropTypes.string.isRequired,
      y: PropTypes.string.isRequired,
      width: PropTypes.string.isRequired,
      height: PropTypes.string.isRequired,
      stroke: PropTypes.string,
      fill: PropTypes.string
    })
  };
  static defaultProps = {
    id: 'scannerInput',
    onChange: () => {},
    onError: () => {},
    eventData: undefined,
    className: undefined,
    scanMilliseconds: 500,
    decodeMilliseconds: 0,
    scanning: true,
    width: undefined,
    height: undefined,
    scanArea: undefined
  };
  constructor(props) {
    super(props);
    this.videoRef = /*#__PURE__*/React.createRef();
    this.state = {
      videoWidth: null,
      videoHeight: null
    };
  }
  componentDidMount() {
    this.startScanner();
    const {
      videoRef
    } = this;
    const self = this;
    videoRef.current.addEventListener('loadedmetadata', function (e) {
      const width = this.videoWidth,
        height = this.videoHeight;
      self.setState({
        videoHeight: height,
        videoWidth: width
      });
    }, false);
    videoRef.current.addEventListener('resize', function (e) {
      const width = this.videoWidth,
        height = this.videoHeight;
      self.setState({
        videoHeight: height,
        videoWidth: width
      });
    }, false);
    this.setState({
      videoHeight: videoRef?.current?.videoHeight,
      videoWidth: videoRef?.current?.videoWidth
    });
  }
  onChange = value => {
    const {
      onChange,
      eventData,
      scanning
    } = this.props;
    if (onChange && scanning) {
      onChange({
        data: eventData,
        value
      });
    }
  };
  onError = error => {
    const {
      onError,
      eventData
    } = this.props;
    if (onError) {
      onError({
        data: eventData,
        error
      });
    }
  };
  startScanner = async () => {
    const {
      constraints = DEFAULT_CONSTRAINTS,
      zxOpts,
      scanMilliseconds
    } = this.props;
    try {
      const {
        decodeFromConstraints
      } = await import('../actions/decode.js');
      const deviceId = await findDesiredCamera();
      this.reader = await decodeFromConstraints(this.videoRef.current, {
        video: {
          ...constraints,
          deviceId
        }
      }, {
        onChange: this.onChange,
        onError: this.onError,
        zxOpts,
        scanMilliseconds
      });
    } catch (error) {
      this.onError(error);
    }
  };
  componentWillUnmount() {
    this.reader?.stop();
  }
  getScanAreaProps() {
    const {
      scanArea
    } = this.props;
    return {
      fill: 'transparent',
      stroke: 'black',
      ...scanArea
    };
  }
  render() {
    const {
      videoHeight,
      videoWidth
    } = this.state;
    const {
      id,
      height,
      width,
      className,
      onChange,
      onError,
      eventData,
      zxOpts,
      scanMilliseconds,
      decodeMilliseconds,
      scanning,
      scanArea,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(className, S.container),
      style: {
        height,
        width
      }
    }, /*#__PURE__*/React.createElement("video", _extends({
      id: id,
      ref: this.videoRef,
      className: S.video
    }, rest, {
      style: {
        width: '100%',
        height: '100%'
      }
    })), scanArea && /*#__PURE__*/React.createElement("svg", {
      viewBox: `0 0 ${videoWidth} ${videoHeight}`,
      className: S.scanArea
    }, /*#__PURE__*/React.createElement("rect", this.getScanAreaProps())));
  }
}